import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

import Api from '@/assets/js/api.js';

async function searchEntriesApi(params) {
    try {
        const response = await Api.get('/theme/v1/publications/search', {
            params: params
        });

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}

async function getCardsApi(params) {
    try {
        const response = await Api.get('/theme/v1/publications/cards', {
            params: params
        });

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}

async function getEntriesApi(params) {
    try {
        const response = await Api.get('/theme/v1/publications/entries', {
            params: params
        });

        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}

// async function searchEntriesApi(obj) {
//     const params = {
//         text: obj.text,
//         termId: obj.termId
//     };

//     return search(params).then((res) => {
//         return res;
//     });
// }

export const B__Publications = () => ({
    url: new URL(window.location.href),
    taxbranch: null,
    search: {
        // isSearch: false,
        termId: 0,
        text: 0
    },
    // viewMode: '', // || 'search' || 'entries'
    filterGroups: [],
    filterCurrentTerm: null,
    spinnerStatusCards: 'idle',
    spinnerStatusEntries: 'idle',
    breadcrumb: [],
    page: null,
    term: null,
    viewMode: '',
    all: {
        cards: [],
        entries: [],
        range: {
            FnTimeout: null,
            years: [],
            from: { min: null, max: null },
            to: { min: null, max: null }
        }
    },
    now: {
        filterIds: [], // Array of term ids from/to url param - parsed to int
        entries: [],
        cards: [],
        range: { show: true, from: null, to: null }
    },

    decideViewMode(textParam, termId) {
        let mode = 'cards';

        if (termId) {
            mode = 'entries';
        }

        /**
         * If param text is present we set search mode to 'search'
         */
        if (textParam) {
            mode = 'search';
        }

        return mode;
    },
    async init() {
        await this.instantiateApp();
    },
    async instantiateApp() {
        let params = this.url.searchParams;

        const termId = params.get('termId')
            ? parseInt(params.get('termId'))
            : 0;

        this.search = {
            text: params.get('text') ?? null,
            termId: termId
        };

        this.viewMode = this.decideViewMode(params.get('text'), termId);

        if (this.viewMode == 'search') {
            // required for search
            // text ?
            // termId ?

            this.now.filterIds = this.getFilterUrlParams(params);

            this.now.range = this.getYearsRangeUrlParams(params);

            this.getSearchEntries();
        }

        if (this.viewMode == 'entries') {
            // required for search

            // termId ?

            this.now.filterIds = this.getFilterUrlParams(params);

            this.now.range = this.getYearsRangeUrlParams(params);

            this.getEntries(termId);
        }

        if (this.viewMode == 'cards') {
            this.getCards();
        }
    },

    setAppBaseData(base) {
        this.term = base.term;
        this.taxbranch = base.taxbranch;
        this.page = base.page;
        this.breadcrumb = base.breadcrumb;

        if (base.length && 'errors' in base.page) {
            console.warn(res.data.page.errors);
            this.page = null;
        }
    },

    async searchEntries() {
        /**
         * get search text and term id from url params
         */

        if (this.search.text == null) {
            document.querySelector('.search-field-group input').focus();
            return;
        }
        this.setSearchAsUrlParams(this.search.text, this.search.termId);

        await this.instantiateApp();
    },

    async changeTerm($event, termId) {
        if ($event) {
            $event.preventDefault();
        }
        let params = this.url.searchParams;

        params.delete('text');

        params.set('termId', termId);

        this.url.search = params.toString();

        window.history.replaceState(null, null, this.url.toString());

        await this.instantiateApp();
    },

    async getCards() {
        /**
         * Set app base
         */

        this.now.entries = [];

        /**
         * Set mode args
         */

        /**
         * get and set needed data - Api call
         */

        this.spinnerStatusCards = await this.setSpinnerStatus('loading'); // show spinner

        if (!this.all.cards.length) {
            const res = await getCardsApi({ termId: this.search.termId });

            if (res.status == 204) {
                // term not found
                this.changeTerm(null, 0);
                return false;
            }

            const base = res.data.base;
            const cards = res.data.cards;

            this.setAppBaseData(base);

            /**
             * initialize app in mode
             */
            this.all.cards = cards; // child terms
            this.now.cards = cards; // child terms
        } else {
            this.now.cards = this.all.cards;
        }

        /**
         * App ready
         */
        this.spinnerStatusCards = await this.setSpinnerStatus('done'); // hide spinner
    },
    async getSearchEntries() {
        /**
         * reset app base
         */
        this.now.cards = [];
        this.now.entries = [];

        /**
         * Set mode args
         */

        /**
         * get and set needed data - Api call
         */
        this.spinnerStatusEntries = await this.setSpinnerStatus('loading'); // show spinner

        const res = await searchEntriesApi({
            text: this.search.text,
            termId: this.search.termId
        });

        if (res.status == 204) {
            // term not found
            this.changeTerm(null, 0);
            return false;
        }

        const base = res.data.base;
        const entries = res.data.entries;
        const filters = res.data.filters;

        this.setAppBaseData(base);
        this.all.entries = entries;

        /**
         * initialize app in mode
         */

        this.filterGroups = await this.addStatusModelAndProcess(
            filters.selectedTermFilters
        );

        this.initializeYearRangeSlider(this.all.entries);

        this.now.entries = this.filterEntries();

        /**
         * App ready
         */

        this.spinnerStatusEntries = await this.setSpinnerStatus('done');
    },

    async getEntries(termId) {
        this.now.cards = [];
        this.now.entries = [];

        if (termId == 0) {
            this.changeTerm(null, 0);
            return;
        }

        /**
         * Set app base
         */
        this.spinnerStatusEntries = await this.setSpinnerStatus('loading'); // show spinner

        /**
         * get and set needed data - Api call
         */
        const res = await getEntriesApi({ termId: termId });

        if (res.status == 204) {
            // term not found
            this.changeTerm(null, 0);
            return false;
        }

        const base = res.data.base;
        const entries = res.data.entries;
        const filters = res.data.filters;

        this.setAppBaseData(base);
        this.all.entries = entries;
        this.filterCurrentTerm = filters.currentTerm;

        /**
         * initialize app in mode
         */
        this.initializeYearRangeSlider(entries);

        this.filterGroups = await this.addStatusModelAndProcess(
            filters.selectedTermFilters
        );

        // this.updateYearFilterOnUserInteraction(
        //     this.now.range.from,
        //     this.now.range.to
        // );

        this.now.entries = this.filterEntries();

        this.spinnerStatusEntries = await this.setSpinnerStatus('done');

        /**
         * App ready
         */
    },
    /**
     * URL GETTER + SETTER
     *
     */
    getFilterUrlParams(params) {
        let arr = [];

        let filterParam = params.get('filters');

        if (filterParam) {
            arr = filterParam.split(',').map((value) => parseInt(value, 10));
        }

        return arr;
    },

    setSearchAsUrlParams(text, termId) {
        let params = this.url.searchParams;

        // params.set('isSearch', true);
        params.set('text', text);
        termId ? params.set('termId', termId) : params.delete('termId');

        this.url.search = params.toString();

        window.history.replaceState(null, null, this.url.toString());
    },

    getYearsRangeUrlParams(params) {
        const obj = {
            from: params.get('year-range-from'),
            to: params.get('year-range-to')
        };

        return obj;
    },

    setYearRangeAsUrlParams(from, to) {
        let params = this.url.searchParams;

        params.set('year-range-from', this.now.range.from);
        params.set('year-range-to', this.now.range.to);

        this.url.search = params.toString();

        window.history.replaceState(null, null, this.url.toString());
    },

    /**
     * activated filter ids (terms ids)
     */
    setFilterIdsAsUrlParams() {
        // console.log(
        //     'setFilterIdsAsUrlParams to (string)',
        //     String(this.now.filterIds)
        // );

        let params = this.url.searchParams;

        params.set('filters', this.now.filterIds.toString());

        this.url.search = params.toString();

        window.history.replaceState(null, null, this.url.toString());
    },
    /**
     * FILTERS
     * @param {*} filterGroups
     * @returns
     */

    async addStatusModelAndProcess(rawfilterGroups) {
        if (!rawfilterGroups.length) return [];

        let filterGroups = await this.addStatusModelToTerms(rawfilterGroups);

        filterGroups = await this.processFilters(filterGroups);

        return filterGroups;
    },

    async processFilters(filterGroups) {
        filterGroups = await this.setFiltersStatus(filterGroups);
        filterGroups = await this.isFilterChecked(filterGroups);

        return filterGroups;
    },

    async addStatusModelToTerms(rawfilterGroups) {
        let filterGroups = rawfilterGroups; // dont change raw data (conceptual reasoning)

        filterGroups.map((filterGroup) => {
            filterGroup.children.map((filter) => {
                filter.status = {
                    enabled: false,
                    checked: false
                };
            });
        });

        return filterGroups;
    },
    async setFiltersStatus(filterGroups) {
        // enabled / disabled filter?
        filterGroups.map((filterGroup) => {
            // remove filters which does not have any entries
            filterGroup.children = filterGroup.children.filter((filter) => {
                let hasEntries = this.all.entries.map((entry) => {
                    return entry.acf.taxonomies.publications_tax_ion.includes(
                        filter.term_id
                    );
                });

                if (hasEntries.includes(true)) return filter;
            });

            // if filterGroup.filter_type is exclusive
            // AND if any children is present in now.filterIds
            // AND child ID from filter group exists in now.filterIds
            // then deactivate other children in group

            if (filterGroup.filter_type == 'exclusive') {
                let hasSelected = this.arraysContainCommonValue(
                    filterGroup.children.map((item) => item.term_id),
                    this.now.filterIds
                );

                if (hasSelected) {
                    filterGroup.children.map((filter) => {
                        filter.status.enabled =
                            this.now.filterIds.indexOf(filter.term_id) > -1
                                ? true
                                : false;
                    });
                } else {
                    // Enable all children
                    filterGroup.children.map((filter) => {
                        filter.status.enabled = true;
                    });
                }
            } else {
                // Enable all children (type == inclusive)
                filterGroup.children.map((filter) => {
                    filter.status.enabled = true;
                });
            }
        });
        return filterGroups;
    },

    async isFilterChecked(filterGroups) {
        this.now.filterIds.map((urlFilterId) => {
            filterGroups.map((filterGroup) => {
                filterGroup.children.map((filter) => {
                    if (filter.term_id == urlFilterId) {
                        filter.status.checked = true;
                    }
                });
            });
        });
        return filterGroups;
    },

    hasPublicationLink(link) {
        // mind model : Publication link is now referenced as the main journal

        if (!link) return false;
        return !!link.hasFile ? link.file.url : link.publication_url;
    },

    hasJournalLink(link) {
        console.log(link);
        if (!link) return false;
        return !!link.hasFile ? link.file.url : this.getJournalUrl(link);
    },

    getJournalLink(link) {
        if (!link) return false;
        return link.hasFile ? link.file.url : this.getJournalUrl(link);
    },

    getJournalUrl(link) {
        // Since jan 2025 - bug fix
        // bug introduced feature more_journals.
        // More journals and publication_url share the same logic and presentational UI
        // but DB key is not the same for the url. hence this fix
        if (!link) return false;
        // if link context is more_journal is the url property is called journal_url
        // if link context is publication is the url property is called publication_url
        return link.journal_url ? link.journal_url : link.publication_url;
    },

    entryHasMoreJournals(item) {
        return (
            item.acf.details.more_journals &&
            item.acf.details.more_journals.length
        );
    },

    async toggleTermFilter(term) {
        // Check if term has other sibling in group checked.
        // If Yes the condition for entries should be "or" between the siblings

        if (!term.status.enabled) {
            return;
        }

        // Toggle item status checked
        term.status.checked = !term.status.checked;

        const termId = term.term_id;

        const filters = this.now.filterIds;

        // ADD or remove TermID to url filters
        if (filters.indexOf(termId) > -1) {
            // remove if exists
            filters.splice(filters.indexOf(termId), 1);
        } else {
            // add if not exists
            filters.push(termId);
        }

        this.now.filterIds = filters;

        this.setFilterIdsAsUrlParams();

        this.filterGroups = await this.processFilters(this.filterGroups);

        this.now.entries = this.filterEntries();
    },

    checkIDInArrays(id, arrays) {
        for (let i = 0; i < arrays.length; i++) {
            if (arrays[i].indexOf(id) === -1) {
                return false; // ID not found in one of the arrays
            }
        }
        return true; // ID found in all of the arrays
    },

    filterEntries() {
        /**
         * compare 2 arrays to find if they have the the same value
         * this.now.filterIds (array of term ids)
         * item.acf.taxonomies.publications_tax_ion (array of entry term ids, not only ion branch)
         */

        let entries = this.all.entries;

        if (this.now.filterIds.length) {
            // console.log(
            //     'since there is no filters in url then show all entries'
            // );

            this.filterGroups.map((group) => {
                const checkedChildren = [];
                group.entryIds = [];
                group.children.map((term) => {
                    if (term.status.checked) {
                        checkedChildren.push(term.term_id);
                    }
                });
                // console.log(group.name, checkedChildren);
                group.checkedChildren = checkedChildren;
            });

            // filter entries  Conditions "OR" || "AND"
            this.all.entries.filter((item, index) => {
                /*
                 *  First we must distribute to each filter group
                 *
                 */
                this.filterGroups.map((group) => {
                    /**
                     * Note regarding acf field: publications_tax_ion.
                     * It is not restricted to _ion branch but holds the
                     * all term branches
                     */

                    // Detect whether the id should be added to the group
                    const shouldAddEntryToGroup = this.arraysContainCommonValue(
                        item.acf.taxonomies.publications_tax_ion,
                        group.checkedChildren
                    );

                    // If yes then add it
                    if (shouldAddEntryToGroup) {
                        // check if ID allready exist in collection
                        group.entryIds.push(item.ID);
                    }
                });
            });

            entries = this.all.entries.filter((item, index) => {
                // Internal fn helper function

                // Later on we need to compare the entryId with entryIds in each filterGroup
                const consideredFilterGroups = this.filterGroups
                    .map((obj) => {
                        if (obj.entryIds.length) {
                            return obj.entryIds;
                        }
                    })
                    // Let the entry pass empty filterGroups
                    .filter((value) => Array.isArray(value));

                // Entry must exist in all considered filterGroups
                return this.checkIDInArrays(item.ID, consideredFilterGroups); // bool
            });
        }

        entries = entries.filter((item) => {
            // if (!item.acf.details.year) {
            //     console.warn(item);
            //     return true;
            // }
            const year = parseInt(item.acf.details.year);

            return year >= this.now.range.from && year <= this.now.range.to;
        });

        return entries;
    },

    async setSpinnerStatus(status) {
        return new Promise(function (resolve, reject) {
            if (status == 'done') {
                setTimeout(() => {
                    status = 'idle';

                    resolve(status);
                }, 800);
            } else {
                resolve(status);
            }
        });
    },

    arraysContainCommonValue(array1, array2) {
        let found = false;

        array1.filter(function (value) {
            if (array2.includes(value)) {
                found = true;
            }
        });

        return found;
    },

    /**
     * RANGE - SLIDER
     */

    initializeYearRangeSlider(entries) {
        if (!entries.length) {
            this.now.range.show = false;
            return;
        }

        this.now.range.show = true;

        const years = entries
            .map((item) => {
                return parseInt(item.acf.details.year);
            })
            .filter((value) => !Number.isNaN(value));

        const UniqueYears = new Set(years.sort());
        // console.log(UniqueYears);

        const minVal = [...UniqueYears][0];
        const maxVal = [...UniqueYears].pop();
        this.all.range.from.min = minVal;
        // this.all.range.from.value = minVal;
        this.all.range.from.max = maxVal;
        this.all.range.to.min = minVal;
        // this.all.range.to.value = maxVal;
        this.all.range.to.max = maxVal;

        // console.log('urlRangeValueObject', this.now.range);

        if (this.now.range) {
            this.now.range.from = this.now.range.from
                ? this.now.range.from
                : minVal;
            this.now.range.to = this.now.range.to ? this.now.range.to : maxVal;
        }

        // this.now.range.from = minVal;
        // this.now.range.to = maxVal;

        this.rangeSliderInit();
    },
    updateYearFilterOnUserInteraction(from, to) {
        // console.log('updateYearFilterOnUserInteraction', from, to);
        if (this.all.range.FnTimeout) {
            clearTimeout(this.all.range.FnTimeout);
        }

        this.all.range.FnTimeout = setTimeout(() => {
            this.now.range.from = from;
            this.now.range.to = to;
            this.setYearRangeAsUrlParams();
            this.now.entries = this.filterEntries();
        }, 200);

        // this.range.from.value = from;
        // this.range.to.value = to;
    },
    rangeSliderInit() {
        if (!document.querySelector('#fromSlider')) {
            return false;
        }

        setTimeout(() => {
            const fromSlider = document.querySelector('#fromSlider');
            const toSlider = document.querySelector('#toSlider');
            const fromInput = document.querySelector('#fromInput');
            const toInput = document.querySelector('#toInput');

            fromSlider.value = this.now.range.from;
            toSlider.value = this.now.range.to;

            this.controlFromSlider(fromSlider, toSlider, fromInput);
            this.controlToSlider(fromSlider, toSlider, toInput);
            this.controlFromInput(fromSlider, fromInput, toInput, toSlider);
            this.controlToInput(toSlider, fromInput, toInput, toSlider);

            this.fillSlider(
                fromSlider,
                toSlider,
                '#C6C6C6',
                '#25daa5',
                toSlider
            );
            this.setToggleAccessible(toSlider);

            fromSlider.oninput = () =>
                this.controlFromSlider(fromSlider, toSlider, fromInput);
            toSlider.oninput = () =>
                this.controlToSlider(fromSlider, toSlider, toInput);
            fromInput.oninput = () =>
                this.controlFromInput(fromSlider, fromInput, toInput, toSlider);
            toInput.oninput = () =>
                this.controlToInput(toSlider, fromInput, toInput, toSlider);
        }, 200);
    },

    controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = this.getParsed(fromInput, toInput);
        this.fillSlider(
            fromInput,
            toInput,
            '#C6C6C6',
            '#25daa5',
            controlSlider
        );
        if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
        } else {
            fromSlider.value = from;
        }
    },

    controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = this.getParsed(fromInput, toInput);
        this.fillSlider(
            fromInput,
            toInput,
            '#C6C6C6',
            '#25daa5',
            controlSlider
        );
        this.setToggleAccessible(toInput);
        if (from <= to) {
            toSlider.value = to;
            toInput.value = to;
        } else {
            toInput.value = from;
        }
    },

    controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = this.getParsed(fromSlider, toSlider);
        this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
        if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
        } else {
            fromInput.value = from;
        }

        this.updateYearFilterOnUserInteraction(from, to);
    },

    controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = this.getParsed(fromSlider, toSlider);
        this.fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
        this.setToggleAccessible(toSlider);
        if (from <= to) {
            toSlider.value = to;
            toInput.value = to;
        } else {
            toInput.value = from;
            toSlider.value = from;
        }

        this.updateYearFilterOnUserInteraction(from, to);
    },

    getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
    },

    fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
          to right,
          ${sliderColor} 0%,
          ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} 100%)`;
    },

    setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
            toSlider.style.zIndex = 2;
        } else {
            toSlider.style.zIndex = 0;
        }
    }
});

export const B__PublicationsEntry = () => ({
    expanded: false,
    player: null,

    expandHandler(item) {
        this.expanded = !this.expanded;

        this.initializeYoutubeVideo(item.acf.details.youtube_video_id);

        if (this.expanded == false && this.player) {
            this.stopVideo();
        }
    },

    init() {
        // 2. This code loads the IFrame Player API code asynchronously.
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        tag.id = 'www-widgetapi-iframe-api';
        // tag.async = true;
        var firstScriptTag = document.getElementsByTagName('script')[0];

        if (firstScriptTag.id !== 'www-widgetapi-iframe-api') {
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    },

    async initializeYoutubeVideo(youtubeId) {
        if (!youtubeId) return;

        if (this.player) return;

        // 4. The API will call this function when the video player is ready.

        // 5. The API calls this function when the player's state changes.
        //    The function indicates that when playing a video (state=1),
        //    the player should play for six seconds and then stop.

        const elemId = 'player_' + youtubeId;

        // 3. This function creates an <iframe> (and YouTube player)
        //    after the API code downloads.

        this.player = new YT.Player(elemId, {
            height: '390',
            width: '640',
            host: 'https://www.youtube-nocookie.com',
            videoId: youtubeId,

            playerVars: {
                playsinline: 1,
                autoplay: 0,
                modestbranding: 1
            },
            events: {
                onReady: this.onPlayerReady,
                onStateChange: this.onPlayerStateChange
            }
        });
    },
    onPlayerStateChange(event) {
        // if (event.data == YT.PlayerState.PLAYING && !done) {
        //     setTimeout(stopVideo, 6000);
        //     //done = true;
        // }
    },
    stopVideo() {
        this.player.stopVideo();
    },
    onPlayerReady(event) {
        // event.target.playVideo();
    }
});

export const RangeSlider = () => ({});
